<template>
    <div class="consulAddDialog">
        <!-- 办理表单 -->
        <el-form
            ref="form"
            :model="form"
            label-width="130px"
            v-if="moduleShow3"
        >
            <!-- <el-form-item label="议题名称">
        <el-input v-model="consultName" disabled></el-input>
      </el-form-item> -->
            <el-form-item label="议题层级">
                <el-input
                    v-model="bargainingLevel"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="议题内容">
                <el-input
                    v-model="content"
                    type="textarea"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="协商内容">
                <el-input
                    v-model="negotiationContent"
                    type="textarea"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="邀请协商人员">
                <el-button
                    v-if="readonlybl !== true"
                    size="mini"
                    type="success"
                    @click="addPersonInfo"
                    >添加</el-button
                >
                <el-table
                    ref="multipleTable"
                    :data="persons"
                    tooltip-effect="dark"
                    style="width: 80%"
                >
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column
                        align="center"
                        label="序号"
                        type="index"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="姓名"
                        prop="name"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="sex"
                        label="性别"
                        width="55"
                    >
                        <template scope="scope">
                            <span v-if="scope.row.sex == 0">男</span>
                            <span v-if="scope.row.sex == 1">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        label="手机号"
                        width="150"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="parentPersonTypeName"
                        label="类别"
                        show-overflow-tooltip
                    ></el-table-column>
                    <!-- <el-table-column label="操作" width="120">
            <template scope="scope">
              <button disabled class="iconfont icon-icon7 tabBtn" style='color:#dd3020;' @click="deleteBtn(scope.$index)"></button>
            </template>
          </el-table-column> -->
                </el-table>
            </el-form-item>

            <el-form-item label="协商时间">
                <el-date-picker
                    :disabled="readonlybls"
                    v-model="form.handleTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    style="width: 90.5%"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="协商地点">
                <el-input
                    :disabled="readonlybls"
                    v-model="form.handlePlace"
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="主持人">
                <el-input
                    :disabled="readonlyjg"
                    v-model="form.host"
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="记录人">
                <el-input
                    :disabled="readonlyjg"
                    v-model="form.record"
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="议事协商记录">
                <el-input
                    :disabled="readonlyjg"
                    v-model="form.noteTaker"
                    type="textarea"
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
                <el-upload
                    class="w650"
                    :class="{ hide: hideUpload }"
                    :limit="1"
                    :disabled="readonlyjg"
                    :action="url"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview2"
                    :on-success="imgok"
                    :file-list="fileListimg"
                    :on-remove="handleRemove2"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible1" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-form-item>
            <el-form-item label="协商结果">
                <el-radio
                    :disabled="readonlyjg"
                    v-model="form.approvalStatus"
                    label="0"
                    >协商结果已达成</el-radio
                >
                <el-radio
                    :disabled="readonlyjg"
                    v-model="form.approvalStatus"
                    label="1"
                    >协商结果未达成</el-radio
                >
            </el-form-item>
            <el-form-item>
                <div class="queRenBtn">
                    <el-button
                        v-if="readonlyjg !== true"
                        type="primary"
                        @click="onSave"
                        >确定</el-button
                    >
                    <el-button v-if="readonlyjg !== true" @click="quXiao"
                        >取消</el-button
                    >
                </div>
            </el-form-item>
        </el-form>
        <el-dialog
            append-to-body=""
            title="添加人员类别"
            :visible.sync="checkpeopType"
            width="900px"
        >
            <peopleTypeDialog
                @func="choosePeopleTypeFunc"
                :isshow="checkpeopType"
                :fatherdata="addformTypeArr"
            ></peopleTypeDialog>
        </el-dialog>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import peopleTypeDialog from "./peopleTypeDialog.vue"
import baseURL from "@/api/baseURL"
export default {
    props: ["ytid", "readonlybl", "readonlyjg"],
    components: { peopleTypeDialog },
    data() {
        return {
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            dialogImageUrl: "", //图片上传,
            dialogVisible1: false, // 上传模态框按钮
            readonlybls: this.readonlybl,
            ConsultOrgOption: [],
            ConsultPersonOptions: [],
            dialogImageUrl: "",
            dialogVisible: false,
            id: this.ytid,
            value1: "",
            radio: "1",
            fits: ["fill", "contain", "cover", "none", "scale-down"],
            form: {
                handleTime: "",
                handlePlace: "",
                host: "",
                record: "",
                noteTaker: "",
                approvalStatus: "",
                photo: "",
            },
            tableData: [],
            multipleSelection: [],
            consultName: "",
            content: "",
            bargainingLevel: "",
            persons: [],
            formPhoto: [],
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            fileListimg: [],
            jiaobanform: {},
            hideUpload: false,
            limitCount: 1,
            moduleShow1: false,
            moduleShow2: false,
            moduleShow3: true,
            addform: {},
            negotiationContent: "",
            orgName: "",
            streetName: "",
            tableData1: [],
            xsytList: [
                {
                    value: "1",
                    label: "党小组、村(居)民组会议",
                },
                {
                    value: "2",
                    label: "群众通过电话或口头等方式",
                },
                {
                    value: "3",
                    label: "群众通过微信、QQ等方式提出",
                },
                {
                    value: "4",
                    label: "党员议事日",
                },
                {
                    value: "5",
                    label: "意见箱",
                },
                {
                    value: "6",
                    label: "包组干部收集到群众的需求",
                },
                {
                    value: "7",
                    label: "落实上级党委政府工作安排",
                },
                {
                    value: "8",
                    label: "其他",
                },
            ],
            xszjList: [
                {
                    value: "1",
                    label:
                        '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项',
                },
                {
                    value: "2",
                    label: '涉及1个村以上"两委"成员包组范围内1村(居)民组事项',
                },
                {
                    value: "3",
                    label: "涉及与本镇内1个村以上范围事项",
                },
                {
                    value: "4",
                    label: "涉及本镇以外其他镇的协商事项",
                },
            ],
            sureList: [
                {
                    value: "0",
                    label: '村"两委"会',
                },
                {
                    value: "1",
                    label: "扩大会",
                },
                {
                    value: "2",
                    label: "党员议事会",
                },
            ],
            tableData: [],
            checkpeopType: false,
            checkpeopType: false,
            addformTypeArr: [],
        }
    },
    computed: {
        // 动态给步骤加样式
        stepClassObj(val) {
            return (val) => {
                return {
                    stepSuc: this.stepSuc.includes(val),
                    stepErr: !this.stepSuc.includes(val),
                }
            }
        },
    },
    methods: {
        // 点击步骤条
        handleStep(val) {
            if (this.stepSuc.includes(val) === true) {
                this.active = val
            }
        },
        getfindConsultHandle() {
            this.hideUpload = false
            this.fileListimg = []
            this.form = {}
            post("admin/consultHandle/info/findConsultHandleByConsultId", {
                consultId: this.ytid,
            }).then((res) => {
                this.form = res.content
                console.log(res)
                console.log("photo", res.content.photo)
                if (res.content.photo) {
                    this.hideUpload = true
                }
                if (this.form.photo) {
                    this.form.photo = res.content.photo.split("#")
                    this.form.photo.map((item1, index) => {
                        if (item1 == "") {
                            this.form.photo.splice(index, 1)
                        }
                    })
                    this.form.photo.map((item) => {
                        this.fileListimg.push({
                            url: item,
                        })
                    })
                }
            })
        },
        // 获取议题编号 街道 社区
        getOrgLevel() {
            // console.log('909090')
            post("admin/user/info/getLoginUserInfo", {
                id: this.$store.state.id,
            }).then((res) => {
                this.orgName = res.content.user.orgName
                this.streetName = res.content.user.streetName
                // console.log(res.content.user.orgName)
            })
        },
        onSave() {
            this.persons = []
            this.tableData.forEach((item) => {
                var person = {}
                this.person = { personId: item.id + "", type: "0" }
                this.persons.push(this.person)
            })
            // console.log(this.formPhoto)
            //循环拼接
            var str = ""
            if (Array.isArray(this.formPhoto)) {
                this.formPhoto.map((item, index) => {
                    str += item + "#"
                })
            } else {
                str = this.form.photo
            }
            this.$set(this.form, "photo", str)
            console.log(this.form)
            post("/admin/consultHandle/info/updateConsultHandle", {
                ...this.form,
                consultId: this.ytid,
                persons: this.persons,
            }).then((res) => {
                // console.log(res);
                this.$emit("close")
            })
        },
        quXiao() {
            this.$emit("close")
            this.persons = []
            this.tableData = []
        },

        // 重置
        getData() {
            this.form = {}
            this.hideUpload = false
            this.consultName = ""
            this.content = ""
            this.bargainingLevel = ""
            this.persons = []
            this.tableData = []
            this.tableData1 = []
            this.fileListimg = []
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleDownload(file) {
            // console.log(file);
        },
        onChange(file, fileList) {
            // console.log(file)
            // console.log(fileList)
        },
        // 上传图片
        handlePictureCardPreview2(file, fileList) {
            this.hideUpload = false
            console.log(fileList)
            if (fileList) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            this.dialogImageUrl = file.url
            this.dialogVisible1 = true
        },
        imgok(data, fileList, data2) {
            this.hideUpload = false
            console.log(fileList)
            if (fileList) {
                this.hideUpload = true
            }
            console.log(data)
            if (data.code == 200) {
                this.formPhoto.push(data.content)
                // console.log(this.formPhoto);
            }
        },
        handleRemove2(file, fileList) {
            this.hideUpload = false
            console.log(fileList)
            if (fileList.length) {
                this.hideUpload = true
            }
            console.log(this.form.photo)
            this.form.photo.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.form.photo.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.form.photo.splice(index, 1)
                    }
                }
            })
            console.log(this.form.photo)
        },
        getFindConsultPersonList() {
            // console.log(this.form.jbr);
            this.form.jbOrg = ""
            post("admin/consulType/info/findConsultPersonList", {
                pageNo: 1,
                pageSize: 100,
                approvalStatus: 1,
                status: 0,
                consultOrgId: this.form.jbr,
            }).then((res) => {
                this.ConsultPersonOptions = res.content.list
            })
        },
        getListConsultOrg() {
            console.log("111---" + this.ytid, this.readonlybl)
            post("admin/consulOrg/info/listConsultOrg", {
                pageNo: 1,
                pageSize: 100,
                status: 0,
            }).then((res) => {
                this.ConsultOrgOption = res.content.list
            })
        },
        getConsultList() {
            // console.log(this.ytid);
            post("/admin/consult/info/findConsultById", {
                id: this.ytid,
            })
                .then((res) => {
                    this.consultName = res.content.consultName
                    this.content = res.content.content
                    if (res.content.bargainingLevel == "1") {
                        this.bargainingLevel =
                            '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项'
                    } else if (res.content.bargainingLevel == "2") {
                        this.bargainingLevel =
                            '涉及1个村以上"两委"成员包组范围内1村(居)民组事项'
                    } else if (res.content.bargainingLevel == "3") {
                        this.bargainingLevel = "涉及与本镇内1个村以上范围事项"
                    } else if (res.content.bargainingLevel == "4") {
                        this.bargainingLevel = "涉及本镇以外其他镇的协商事项"
                    }
                    this.persons = []
                    res.content.persons.filter((item) => {
                        if (item.type == "0") {
                            this.persons.push(item)
                        }
                    })
                    this.negotiationContent = res.content.negotiationContent
                })
                .catch(() => {})
        },
        addPersonInfo() {
            this.tableData = []
            // console.log(this.tableData)
            this.checkpeopType = true
        },
        // 选择人员类别返回选中成员
        choosePeopleTypeFunc(val) {
            this.tableData = []
            this.addformTypeArr = []
            // console.log(val)
            this.checkpeopType = false
            this.addformTypeArr.push(val)
            // console.log(this.addformTypeArr)
            // this.addformTypeArr.forEach(item => {
            //   console.log(item.persionArr)
            //   console.log(item.persionArr[0])
            //   this.tableData.push(item.persionArr[0])
            // })
            this.tableData = this.addformTypeArr[0].persionArr
            // console.log(this.tableData)
        },
        // deleteBtn1(index) {
        //   console.log(index)
        //   this.tableData1.splice(index, 1)
        // },
        deleteBtn(index) {
            // console.log(index)
            this.tableData.splice(index, 1)
            // this.tableData.forEach(item => {
            //   if(item.id == id){
            //     this.tableData.splice(item,1)
            //   }
            // })
            // console.log(this.tableData)
        },
    },
    mounted() {
        console.log("======", this.ytid, this.readonlybl, this.readonlyjg)
        this.getListConsultOrg()
        this.getConsultList()
        this.getfindConsultHandle()
    },
}
</script>

<style lang="less" scoped>
.consulAddDialog {
    .el-form-item {
        margin-bottom: 10px;
        .el-form-item__error {
            top: 85%;
        }
    }
}
.queRenBtn {
    margin-top: 30px;
    margin-left: -130px;
    display: flex;
    justify-content: center;
}
.queRenBtn {
    .qubtn {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn :hover {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn_span {
        color: #409eff;
        margin-top: 10px;
    }
}
.hide {
    /deep/.el-upload--picture-card {
        display: none;
    }
}
</style>